import { render, staticRenderFns } from "./technical-assistance.vue?vue&type=template&id=1bf6dabe&scoped=true"
import script from "./technical-assistance.vue?vue&type=script&lang=js"
export * from "./technical-assistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6dabe",
  null
  
)

export default component.exports